"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.goal.efficiency': 'Efficiency',
    'slot.goal.accuracy': 'Accuracy',
    'slot.goal.creativity': 'Creativity',
    'slot.goal.detail': 'Detail',
};
